var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstimatedReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.75H7C4.65279 2.75 2.75 4.65279 2.75 7V17C2.75 19.3472 4.65279 21.25 7 21.25H17C19.3472 21.25 21.25 19.3472 21.25 17V7C21.25 4.65279 19.3472 2.75 17 2.75Z",
    stroke: "#D80587",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.711 8.96069C16.711 8.54648 16.3752 8.21069 15.961 8.21069H13.1325C12.7183 8.21069 12.3825 8.54648 12.3825 8.96069C12.3825 9.37491 12.7183 9.71069 13.1325 9.71069H14.1503L11.7346 12.1264L10.3041 10.6959C10.0112 10.403 9.53634 10.403 9.24345 10.6959L6.06147 13.8779C5.76857 14.1708 5.76857 14.6457 6.06147 14.9386C6.35436 15.2315 6.82923 15.2315 7.12213 14.9386L9.77378 12.2869L11.2042 13.7174C11.4971 14.0103 11.972 14.0103 12.2649 13.7174L15.211 10.7713V11.7891C15.211 12.2033 15.5468 12.5391 15.961 12.5391C16.3752 12.5391 16.711 12.2033 16.711 11.7891V8.96069Z",
    fill: "#D80587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimatedReturn);
export default __webpack_public_path__ + "static/media/estimated-return.647bba3cf2e6735c7193fea678b90377.svg";
export { ForwardRef as ReactComponent };